var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2C4.46714 2 2 4.46714 2 7.5C2 10.5329 4.46714 13 7.5 13C10.5329 13 13 10.5329 13 7.5C13 4.46714 10.5329 2 7.5 2ZM7.5 4.35714C8.58018 4.35714 9.46429 5.24125 9.46429 6.32143C9.46429 6.77979 9.33862 7.14748 9.14668 7.41941C8.95472 7.69133 8.71779 7.86365 8.52136 8.01098C8.32493 8.15832 8.16902 8.28064 8.06632 8.42611C7.96363 8.57159 7.89287 8.74408 7.89287 9.07143H7.10715C7.10715 8.61307 7.23281 8.24537 7.42476 7.97345C7.61672 7.70152 7.85365 7.52921 8.05008 7.38187C8.2465 7.23454 8.40241 7.11222 8.50512 6.96675C8.6078 6.82127 8.67857 6.64887 8.67857 6.32143C8.67857 5.66585 8.15558 5.14286 7.5 5.14286C6.84442 5.14286 6.32143 5.66585 6.32143 6.32143H5.53571C5.53571 5.24125 6.41982 4.35714 7.5 4.35714ZM7.10714 9.85714H7.89286V10.6429H7.10714V9.85714Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQuestion);
export default __webpack_public_path__ + "static/media/ico_question.e6b5e199b50191b6f265de7eb8a2b5a8.svg";
export { ForwardRef as ReactComponent };